<script>
  import { getOr, get } from '../../helpers/get';
  import CoinIcon from '../CoinIcon.svelte';

  export let bundle; // Bundle
  export let showSupersededCoinsAmount = true;

  $: base = getOr('coins.base', bundle.coinsAmount, bundle);
  $: bonus = get('coins.bonus', bundle);
  $: supersededCoinsAmount = bundle.supersededCoinsAmount;
</script>

<style lang="stylus">
  .bonus
    font-size 20px
    line-height 24px
    font-weight bold
    color $violet
    vertical-align bottom

  .coins-amount :global(img.coin-icon)
    vertical-align bottom

  .coins
    font-size: 20px
    line-height: 24px
    font-weight: bold
    vertical-align bottom

  .yellow
    color #FFCA36

  .superseded
    text-decoration line-through
    color #DCDCDC
    font-size 16px
</style>

<div class="coins-amount">
  {#if supersededCoinsAmount && showSupersededCoinsAmount}
    <span class="superseded">{supersededCoinsAmount}</span>
  {/if}
  <span class="coins" class:yellow={!!supersededCoinsAmount}>{base}</span><CoinIcon />
  {#if bonus}
    <span class="bonus">
      + {bonus}
    </span>
  {/if}
</div>
